var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 289,
    viewBox: "0 0 306 289",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.867 38.2039H195.881V40.8213V56.2289V58.8546H170.4V40.8213H183.017L183.867 38.2039Z",
    fill: "#01C1D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M183.867 77.4987H195.881V80.1162V95.5238V98.1495H170.4V80.1162H183.017L183.867 77.4987Z",
    fill: "#01C1D5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M183.867 116.794H195.881V119.411V134.819V137.445H170.4V119.411H183.017L183.867 116.794Z",
    fill: "#01C1D5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M183.867 156.089H195.881V158.706V174.114V176.739H170.4V158.706H183.017L183.867 156.089Z",
    fill: "#01C1D5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M183.867 195.384H195.881V198.009V213.409V216.034H170.4V198.009H183.017L183.867 195.384Z",
    fill: "#01C1D5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.846 38.2039H118.86V40.8213V56.2289V58.8546H93.3705V40.8213H105.987L106.846 38.2039Z",
    fill: "#01C1D5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8666 40.8213L57.7254 38.2039H69.7393V40.8213V56.2289V58.8546H44.2582V40.8213H56.8666Z",
    fill: "#01C1D5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.846 77.4987H118.86V80.1162V95.5238V98.1495H93.3705V80.1162H105.987L106.846 77.4987Z",
    fill: "#01C1D5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7254 116.794H69.7393V119.411V134.819V137.445H44.2582V119.411H56.8666L57.7254 116.794Z",
    fill: "#01C1D5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7254 77.4987H69.7393V80.1162V95.5238V98.1495H44.2582V80.1162H56.8666L57.7254 77.4987Z",
    fill: "#01C1D5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M106.846 116.794H118.86V119.411V134.819V137.445H93.3705V119.411H105.987L106.846 116.794Z",
    fill: "#01C1D5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M106.846 156.089H118.86V158.706V174.114V176.739H93.3705V158.706H105.987L106.846 156.089Z",
    fill: "#01C1D5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7254 156.089H69.7393V158.706V174.114V176.739H44.2582V158.706H56.8666L57.7254 156.089Z",
    fill: "#01C1D5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M106.846 195.384H118.86V198.009V213.409V216.034H93.3705V198.009H105.987L106.846 195.384Z",
    fill: "#01C1D5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7254 195.384H69.7393V198.009V213.409V216.034H44.2582V198.009H56.8666L57.7254 195.384Z",
    fill: "#01C1D5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M183.868 38.2039H195.882V40.8213V56.2289V58.8546H170.401V40.8213H183.017L183.868 38.2039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M183.868 77.4987H195.882V80.1162V95.5238V98.1495H170.401V80.1162H183.017L183.868 77.4987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M183.868 116.794H195.882V119.411V134.819V137.444H170.401V119.411H183.017L183.868 116.794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M183.868 156.089H195.882V158.706V174.114V176.739H170.401V158.706H183.017L183.868 156.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M183.868 195.384H195.882V198.009V213.409V216.034H170.401V198.009H183.017L183.868 195.384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M106.846 38.2039H118.86V40.8213V56.2289V58.8546H93.3708V40.8213H105.987L106.846 38.2039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M56.8666 40.8213L57.7254 38.2039H69.7393V40.8213V56.2289V58.8546H44.2582V40.8213H56.8666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M106.846 77.4987H118.86V80.1162V95.5238V98.1495H93.3708V80.1162H105.987L106.846 77.4987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M57.7254 116.794H69.7393V119.411V134.819V137.444H44.2582V119.411H56.8666L57.7254 116.794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M57.7254 77.4987H69.7393V80.1162V95.5238V98.1495H44.2582V80.1162H56.8666L57.7254 77.4987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M106.846 116.794H118.86V119.411V134.819V137.444H93.3708V119.411H105.987L106.846 116.794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M106.846 156.089H118.86V158.706V174.114V176.739H93.3708V158.706H105.987L106.846 156.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M57.7254 156.089H69.7393V158.706V174.114V176.739H44.2582V158.706H56.8666L57.7254 156.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M106.846 195.384H118.86V198.009V213.409V216.034H93.3708V198.009H105.987L106.846 195.384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M57.7254 195.384H69.7393V198.009V213.409V216.034H44.2582V198.009H56.8666L57.7254 195.384Z",
    fill: "white"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M182.067 288.993C159.038 288.993 140.369 285.112 140.369 280.323C140.369 275.535 159.038 271.654 182.067 271.654C205.096 271.654 223.765 275.535 223.765 280.323C223.765 285.112 205.096 288.993 182.067 288.993Z",
    fill: "#01C1D5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M182.067 288.993C159.038 288.993 140.369 285.112 140.369 280.323C140.369 275.535 159.038 271.654 182.067 271.654C205.096 271.654 223.765 275.535 223.765 280.323C223.765 285.112 205.096 288.993 182.067 288.993Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M151.17 96.2257C151.17 96.2257 151.335 91.8082 151.335 87.2173C151.335 82.6264 148.957 81.6108 147.429 81.6108C146.688 81.5879 145.946 81.6433 145.216 81.7759C145.216 81.7759 144.391 74.4685 138.924 73.2795C133.458 72.0905 129.404 76.508 127.538 74.9804C125.672 73.4529 131.956 73.618 129.239 71.4134C126.522 69.2088 118.695 69.0272 117.844 77.1933C116.994 85.3595 122.609 89.0916 125.325 89.7687C128.042 90.4458 131.79 85.5163 135.357 85.6897C138.924 85.8631 138.413 89.9421 140.625 91.643C142.838 93.344 144.539 92.4687 144.539 94.6981C144.539 96.9275 145.555 98.1 148.28 98.2651C151.004 98.4303 151.17 96.2257 151.17 96.2257Z",
    fill: "#0C4284",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M125.978 83.0805C125.978 83.0805 123.327 84.3025 119.868 82.0649C116.408 79.8272 118.654 74.7409 119.257 74.5345",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M141.443 81.8584C141.443 81.8584 140.221 76.5656 135.952 76.7721C131.683 76.9785 132.286 80.8428 128.62 82.0648",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M143.673 85.1778C143.673 85.1778 146.15 82.7007 148.346 83.287C150.542 83.8732 149.568 87.7623 149.362 88.9843C149.155 90.2063 150.79 93.666 150.79 93.666",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M201.083 99.1238L194.94 121.054L185.106 120.642L190.845 98.5128L201.083 99.1238Z",
    fill: "#0C4284",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M184.899 140.111L187.566 141.54C187.566 141.54 190.869 131.293 192.273 127.404C193.676 123.515 194.122 121.872 194.122 121.872H194.056C193.355 121.466 192.802 120.846 192.479 120.103C192.157 119.36 192.081 118.533 192.264 117.743L192.735 115.654C192.664 115.845 192.548 116.016 192.399 116.155C192.249 116.293 192.069 116.394 191.873 116.45C191.677 116.507 191.471 116.516 191.271 116.478C191.071 116.44 190.882 116.356 190.72 116.232C190.035 115.786 190.762 111.278 191.587 109.627C192.413 107.975 195.146 109.189 195.964 109.627C196.565 109.963 197.121 110.376 197.615 110.857L198.226 108.38C198.226 108.38 195.154 108.173 194.535 108.173C193.916 108.173 191.67 106.126 192.694 105.919C193.718 105.713 199.456 105.713 200.893 106.943C202.33 108.173 199.869 113.095 199.456 114.119C199.043 115.142 196.979 125.596 196.153 128.461C195.328 131.326 193.28 152.406 192.025 154.28C190.77 156.155 181.654 147.485 181.654 147.485L184.899 140.111Z",
    fill: "white",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M196.913 112.335C196.913 112.335 194.032 109.858 191.439 110.469",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M196.046 114.771C195.427 114.139 194.689 113.635 193.874 113.289C193.059 112.944 192.184 112.762 191.299 112.756",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M163.068 113.739C163.068 113.739 166.866 117.363 168.509 120.435C170.153 123.507 185.717 140.111 185.717 140.111L181.209 155.478L170.144 146.048C170.144 146.048 164.001 134.166 162.358 126.586C160.715 119.007 159.262 113.598 163.068 113.739Z",
    fill: "#01C1D5",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M129.066 117.818C129.066 117.818 141.138 116.794 147.933 115.778C154.729 114.763 162.218 112.888 163.068 113.739C163.919 114.589 169.253 141.292 174.455 151.985C181.341 166.146 186.081 173.652 186.081 173.652C181.305 171.817 176.116 171.34 171.086 172.273C162.589 173.8 149.362 182.833 149.362 182.833C149.362 182.833 143.004 169.151 136.208 155.387C129.413 141.623 125.838 121.046 125.838 119.882C125.838 118.718 128.05 117.644 129.066 117.818Z",
    fill: "#01C1D5",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M134.235 117.347C138.364 116.959 144.011 116.364 147.934 115.778C148.512 115.695 149.081 115.596 149.659 115.506C150.474 117.784 150.982 120.161 151.17 122.574C151.509 127.528 148.619 132.944 146.406 132.944C144.193 132.944 137.398 123.771 135.87 121.219C135.114 120.028 134.562 118.719 134.235 117.347Z",
    fill: "white",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M145.389 106.258C145.389 106.258 147.082 114.928 148.444 118.495C149.807 122.062 148.279 128.353 146.578 128.527C144.877 128.7 138.073 119.857 138.073 119.857L135.695 109.998C135.695 109.998 144.365 107.62 145.389 106.258Z",
    fill: "white",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M127.522 118.181C126.615 118.323 125.755 118.675 125.008 119.208C124.261 119.741 123.649 120.441 123.22 121.252C121.569 124.126 105.187 151.374 105.187 151.374L116.259 154.247L131.626 140.516C131.626 140.516 135.308 135.801 131.213 127.404",
    fill: "#01C1D5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M127.522 118.181C126.615 118.323 125.755 118.675 125.008 119.208C124.261 119.741 123.649 120.441 123.22 121.252C121.569 124.126 105.187 151.374 105.187 151.374L116.259 154.247L131.626 140.516C131.626 140.516 135.308 135.801 131.213 127.404",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M159.493 144.001C159.493 144.001 163.382 147.485 163.621 148.302C163.861 149.12 161.573 152.431 160.954 152.604C160.335 152.778 160.128 150.953 160.343 150.127C160.558 149.302 160.954 148.071 160.954 148.071L158.708 145.413C158.708 145.413 157.85 144.413 159.493 144.001Z",
    fill: "white",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M109.497 144.818C111.976 143.905 114.61 143.487 117.25 143.588C121.552 143.794 130.569 146.065 136.307 146.255C142.046 146.445 141.84 146.668 144.911 145.842C147.983 145.016 154.332 140.112 155.769 140.112C157.206 140.112 161.508 147.279 160.888 148.096C160.269 148.913 155.158 152.811 153.721 153.05C152.285 153.29 149.213 151.399 149.213 151.399C149.213 151.399 133.847 153.653 126.671 154.479C119.496 155.304 110.686 156.32 107.21 154.066C103.734 151.812 104.782 146.866 109.497 144.818Z",
    fill: "white",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M155.802 142.564L159.699 148.715",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M152.937 144.818L157.445 150.969",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M150.881 147.485L154.778 152.2",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M149.246 151.374L149.659 149.946L151.706 151.176",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M124.987 95.5485C124.987 95.5485 123.286 94.3595 122.947 97.588C122.609 100.816 123.773 103.029 124.648 103.541C125.524 104.053 126.514 103.194 126.514 103.194L124.987 95.5485Z",
    fill: "white",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M149.452 96.0606C149.452 96.0606 152.169 92.4854 153.696 95.5487C155.224 98.6121 154.043 102.518 151.995 104.045C149.948 105.573 147.916 103.368 147.916 103.368C147.916 103.368 143.499 112.376 139.758 112.715C136.018 113.054 129.024 110.337 126.498 105.069C123.971 99.8011 124.293 91.2964 123.955 88.0679C123.616 84.8394 127.183 80.7604 133.813 80.7604C135.682 80.715 137.537 81.0882 139.243 81.8525C140.949 82.6169 142.462 83.7531 143.672 85.1779C143.42 85.3087 143.202 85.4957 143.034 85.7244C142.866 85.953 142.753 86.2173 142.704 86.4967C142.654 86.776 142.67 87.0631 142.749 87.3355C142.828 87.608 142.969 87.8586 143.16 88.0679C144.523 89.9422 146.215 91.1312 146.727 92.3202C147.239 93.5092 146.727 94.6982 147.413 95.7221C148.098 96.746 149.452 96.0606 149.452 96.0606Z",
    fill: "white",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M134.053 90.6356C134.201 91.5852 134.68 92.287 135.118 92.2375C135.555 92.1879 135.803 91.3374 135.654 90.3879C135.506 89.4383 135.027 88.7365 134.589 88.786C134.152 88.8356 133.904 89.6778 134.053 90.6356Z",
    fill: "#0C4284"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M127.258 92.4771C127.406 93.4349 127.885 94.1285 128.323 94.0789C128.76 94.0294 129.008 93.1872 128.86 92.2294C128.711 91.2715 128.232 90.578 127.794 90.6275C127.357 90.677 127.109 91.5523 127.258 92.4771Z",
    fill: "#0C4284"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M137.414 86.6475C137.414 86.6475 135.292 84.1704 132.551 85.5246",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M128.431 87.5228C128.431 87.5228 125.318 86.3999 124.69 90.644",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M129.801 90.7595C129.801 90.7595 130.924 92.8816 130.676 93.5008C130.428 94.1201 127.307 94.8715 128.306 95.7467C129.305 96.622 131.799 97.6211 132.55 97.1174",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M139.156 97.489C139.156 97.489 138.281 100.486 134.293 101.106",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M184.611 172.272C184.611 172.272 189.169 176.822 195.716 183.659C202.264 190.496 219.067 213.557 217.358 221.286C215.649 229.014 173.505 240.649 173.505 240.649L168.955 237.519C168.955 237.519 194.296 218.726 196.005 214.449C197.715 210.172 175.784 196.226 175.784 196.226L151.294 180.538C151.294 180.538 162.259 162.017 184.611 172.272Z",
    fill: "#0C4284",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M153.862 160.878C153.862 160.878 148.453 169.961 149.023 180.81C149.593 191.66 153.862 201.312 164.398 201.032C174.934 200.751 174.075 184.798 170.656 176.822C167.238 168.846 166.677 158.318 153.862 160.878Z",
    fill: "#0C4284",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M169.269 166.286C169.269 166.286 175.247 193.906 178.096 199.314C180.945 204.722 186.072 217.818 186.072 217.818L179.805 219.527C179.805 219.527 170.978 207.282 160.443 194.467C149.907 181.652 151.616 164.569 153.895 160.87C156.174 157.17 164.967 157.459 169.269 166.286Z",
    fill: "#0C4284",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M152.293 171.744C152.293 171.744 156.991 191.387 163.399 199.504",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M173.505 240.607C173.505 240.607 172.679 245.165 174.331 248.295C175.982 251.424 180.028 257.98 177.18 258.261C174.331 258.542 170.343 254.273 167.494 250.83C164.645 247.386 164.365 244.273 162.366 241.747C160.368 239.22 168.923 237.478 168.923 237.478L172.655 239.451L173.505 240.607Z",
    fill: "#01C1D5",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M162.399 241.747C161.722 240.871 162.276 240.095 163.299 239.451C165.28 243.774 167.698 247.883 170.516 251.713C173.497 255.585 176.246 256.667 178.187 256.791C178.245 257.617 177.997 258.186 177.212 258.261C174.364 258.55 170.376 254.273 167.527 250.829C164.678 247.386 164.398 244.306 162.399 241.747Z",
    fill: "white",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M186.039 217.826C189.556 217.365 192.945 216.203 196.005 214.408C200.555 211.568 201.413 211.568 201.413 216.687C201.413 221.806 195.146 224.374 191.728 226.942C188.309 229.51 186.32 230.93 183.76 230.641C181.2 230.352 179.772 219.536 179.772 219.536C179.772 219.536 181.192 216.687 186.039 217.826Z",
    fill: "#01C1D5",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M201.413 216.687C201.413 221.815 195.146 224.374 191.728 226.942C188.309 229.51 186.353 230.897 183.826 230.641C189.796 226.843 190.432 220.733 196.005 214.408C200.555 211.568 201.413 211.568 201.413 216.687Z",
    fill: "white",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M187.599 224.093C189.069 221.296 190.758 218.621 192.653 216.092C193.817 215.643 194.939 215.091 196.005 214.441C200.555 211.601 201.413 211.601 201.413 216.72C201.413 221.839 195.146 224.407 191.728 226.975C188.309 229.543 186.32 230.963 183.76 230.674C183.132 230.608 182.579 229.906 182.109 228.891C183.329 228.562 184.457 227.959 185.409 227.127C186.361 226.296 187.11 225.258 187.599 224.093V224.093Z",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M272.557 127.693C272.557 127.28 272.482 126.867 272.441 126.463",
    stroke: "#0C4284",
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M272.16 124.01C268.514 94.8851 254.38 68.0863 232.404 48.6285C210.427 29.1707 182.113 18.3874 152.761 18.2963C123.408 18.2052 95.0283 28.8126 72.9313 48.1336C50.8342 67.4546 36.5344 94.1652 32.7076 123.267",
    stroke: "#0C4284",
    strokeMiterlimit: 10,
    strokeDasharray: "2.98 2.98"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5337 124.497C32.4841 124.902 32.4346 125.323 32.3933 125.728",
    stroke: "#0C4284",
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M256.224 43.9919L266.909 77.3089L224.592 83.7163L217.326 52.959C217.326 52.959 242.988 51.2498 256.224 43.9919Z",
    fill: "white",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M212.205 22.6312C212.205 22.6312 192.133 24.7697 177.609 14.9439C177.609 14.9439 159.674 29.0386 152.838 30.3267C152.838 30.3267 163.514 41.8865 174.62 45.2718C174.644 45.2718 201.983 32.8863 212.205 22.6312Z",
    fill: "white",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M212.205 22.6312C209.258 20.3951 205.887 18.7825 202.297 17.8917C201.93 24.0125 199.51 29.8308 195.427 34.4056C195.427 34.4056 207.837 27.7092 212.205 22.6312Z",
    fill: "#0C4284",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M132.939 36.6597C132.939 36.6597 133.649 38.7982 129.38 42.357C127.44 44.0084 123.064 44.6194 123.064 44.6194L111.587 30.2523C111.587 30.2523 130.421 32.8119 132.939 36.6597Z",
    fill: "#0C4284",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M132.939 36.6597C126.626 34.4828 119.97 33.4701 113.296 33.6707C110.114 33.8257 106.996 34.625 104.132 36.0201C101.268 37.4153 98.7166 39.3773 96.633 41.7873L84.2475 26.4045C84.2475 26.4045 94.9568 16.587 106.929 17.0081C118.902 17.4292 132.113 33.2413 132.939 36.6597Z",
    fill: "white",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M60.98 44.8754C60.98 44.8754 68.6672 65.0968 85.4619 67.9454C85.4619 67.9454 68.6672 87.8778 59.2708 90.1567C59.2708 90.1567 40.1889 81.6107 35.0613 72.5033C35.0613 72.5033 51.8642 62.8179 60.98 44.8754Z",
    fill: "white",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M244.268 147.873L236.803 116.241H286.907L287.972 147.873H244.268Z",
    fill: "#0C4284",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M281.285 104.524L281.441 140.855L243.955 144.661L241.131 106.035L281.285 104.524Z",
    fill: "white",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M293.661 110.56L287.972 147.873H244.268L247.108 114.11H270.558L272.697 109.85L293.661 110.56Z",
    fill: "#01C1D5",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0577 147.873L63.522 116.241H13.4186L12.3534 147.873H56.0577Z",
    fill: "#0C4284",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0421 104.524L18.8852 140.855L56.3719 144.661L59.1958 106.035L19.0421 104.524Z",
    fill: "white",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66482 110.56L12.3539 147.873H56.0581L53.2177 114.11H29.7596L27.6293 109.85L6.66482 110.56Z",
    fill: "#01C1D5",
    stroke: "#0C4284",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImage);
export default __webpack_public_path__ + "static/media/profile-image.6165f57d565af6810e70a9f5bd3a6db4.svg";
export { ForwardRef as ReactComponent };